import type { NewsContentAlignment, NewsContentImageNode } from './client';

const NEWS_CONTENT_IMAGE_MAX_DIMENSION = 10000;

const normalizeAlignment = (value: unknown): NewsContentAlignment =>
  value === 'center' || value === 'right' ? value : 'left';

export const getStringAttribute = (
  attributes:
    | {
        alt?: string;
        href?: string;
        src?: string;
      }
    | undefined,
  attributeName: 'alt' | 'href' | 'src'
): string | undefined => {
  const value = attributes?.[attributeName];

  return typeof value === 'string' ? value : undefined;
};

export const getImageDimension = (
  attributes: NewsContentImageNode['attrs'],
  attributeName: 'height' | 'width'
): number | undefined => {
  const value = attributes?.[attributeName];

  if (
    typeof value !== 'number' ||
    !Number.isFinite(value) ||
    value <= 0 ||
    value > NEWS_CONTENT_IMAGE_MAX_DIMENSION
  ) {
    return undefined;
  }

  return value;
};

export const getImageAlignment = (
  attributes: NewsContentImageNode['attrs']
): NewsContentAlignment => {
  return normalizeAlignment(attributes?.align);
};

export const getTextAlignment = (
  attributes:
    | {
        textAlign?: NewsContentAlignment;
      }
    | undefined
): NewsContentAlignment => {
  return normalizeAlignment(attributes?.textAlign);
};

export const isSafeLink = (href: string): boolean => {
  try {
    const url = new URL(href);

    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
